import { Product } from '@core/models/piramide/Product';
import { Incompatibilities } from '../Incompatibilities';
import { PlacaVideo } from '../model';
import { DataArmado } from './DataArmado';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

export abstract class FuncionesArmadoBase<T extends Product> {
  abstract funciones: { [x: string]: (arg1: DataArmado, arg2: T) => Incompatibilities[] };

  ejecutar(dataArmado: DataArmado, objetoB: T): Incompatibilities[] {
    let resultado: Incompatibilities[] = [].concat.apply(
      [],
      Object.keys(this.funciones)
        .map((key) => this.funciones[key](dataArmado, objetoB))
        .filter((incomp) => incomp),
    );
    let stock = this.funcionStock(objetoB);
    let resultadoFuente = this.funcionFuente(dataArmado, objetoB);
    if (resultadoFuente) resultado.push(resultadoFuente);
    if (stock) resultado.push(stock);
    return resultado;
  }
  funcionStock(producto: T) {
    return producto.stock ? null : (
        {
          tipo: IncompatibilitiesType.STOCK,
          incompatibility: 'El producto no tiene stock',
        }
      );
  }
  private funcionFuente(dataArmado: DataArmado, producto: T): Incompatibilities {
    let fuente = dataArmado.fuentes[0];
    if (!fuente) {
      const gabinete = dataArmado.gabinetes[0];
      if (gabinete?.$caracteristicas?.kit == 1 && gabinete?.$caracteristicas?.id_fuente > 0) {
        fuente = gabinete.$caracteristicas.$caracteristicas_fuente;
      } else {
        return null;
      }
    }
    let consumoMaximo = fuente.$caracteristicas.w_real;
    let elementos: Product[] = [].concat.apply([], Object.values(dataArmado));
    elementos.push(producto);
    let consumoTotal = 0;
    consumoTotal = elementos.reduce<number>((anterior, producto) => {
      let consumo = producto?.$caracteristicas['w'] ? producto.$caracteristicas['w'] : 0;
      return anterior + consumo;
    }, 0);
    if (consumoTotal >= consumoMaximo) {
      if (producto instanceof PlacaVideo)
        return {
          tipo: IncompatibilitiesType.CANTIDAD,
          incompatibility: 'La fuente no soporta otra placa de video con este consumo',
        };
      return {
        tipo: IncompatibilitiesType.ENERGIA,
        incompatibility: 'Excede el consumo máximo de la fuente',
      };
    }
    return null;
  }
}
